<template>
    <div>

        <div v-if="loading" class="tw-bg-white tw-p-5 tw-flex tw-flex-col tw-gap-5 tw-py-10">
            <div class="tw-h-[20px] tw-w-full tw-bg-gray-100 tw-animate-pulse tw-rounded"></div>
            <div class="tw-h-[40px] tw-w-full tw-bg-gray-100 tw-animate-pulse tw-rounded"></div>
            <div class="tw-h-[20px] tw-w-full tw-bg-gray-100 tw-animate-pulse tw-rounded"></div>
            <div class="tw-h-[40px] tw-w-full tw-bg-gray-100 tw-animate-pulse tw-rounded"></div>
            <div class="tw-h-[20px] tw-w-full tw-bg-gray-100 tw-animate-pulse tw-rounded"></div>
        </div>

        <div v-else class="tw-pb-5 tw-pt-5 tw-px-4 tw-bg-white tw-flex tw-flex-col tw-gap-2">
            <div v-for="h in data" :key="h.id" class="tw-border tw-border-gray-200 tw-rounded">
                <div class="tw-flex tw-items-center tw-justify-between tw-p-2 tw-bg-gray-200">
                    <div class="tw-flex tw-items-center tw-gap-2 tw-text-xs tw-uppercase tw-font-semibold">
                        <icon icon="solar:user-rounded-bold-duotone" class="tw-text-xl tw-text-gray-700" />
                        <p>{{ h.action_by }}</p>
                    </div>
                    <div class="tw-text-xs tw-font-medium" @mouseenter="h.hovering = true"
                        @mouseleave="h.hovering = false">
                        <p v-if="!h.hovering">{{ moment(h.created_at).format('MMMM Do, YYYY [at] h:mm A') }}
                        </p>
                        <p v-else>{{ moment(h.created_at).locale($i18n.locale).fromNow() }}</p>
                    </div>
                </div>

                <div class="tw-p-2x tw-border-tx tw-border-solid tw-border-gray-200">
                    <div class="tw-rounded tw-borderx tw-border-solid tw-border-gray-100 tw-overflow-autox">
                        <table class="tw-min-w-full tw-leading-normal tw-w-full">
                            <thead class="">
                                <tr>
                                    <th v-for="c in columns" :key="c.name" :class="c.classes"
                                        class="tw-px-2 tw-text-[10px] last:tw-border-e-0 tw-whitespace-nowrap tw-border-e tw-py-1 tw-border-b tw-borderx tw-border-gray-100 tw-bg-gray-50 tw-text-start tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider">
                                        {{ $t(c.label) }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr :key="f.field" v-for="f in h.fields"
                                    class="tw-border-b tw-border-solid tw-border-gray-100 last:tw-border-b-0 tw-group even:tw-bg-gray-50/50 hover:tw-bg-primary-50/60 tw-duration-100">
                                    <td class="tw-text-xs tw-px-2 tw-py-1 tw-font-semibold">{{ $t('fields.'
                                        + f.field) }}</td>

                                    <template v-if="f.field == 'agent_status' || f.field == 'followup_status'">
                                        <td class="tw-text-xs tw-px-2 tw-py-1 tw-text-amber-700">{{ $t(
                                            'order-status.confirmation.' + f.old_value) }}</td>
                                        <td class="tw-text-xs tw-px-2 tw-py-1 tw-text-green-700">{{ $t(
                                            'order-status.confirmation.' + f.new_value) }}</td>
                                    </template>
                                    <template v-else-if="f.field == 'delivery_status'">
                                        <td class="tw-text-xs tw-px-2 tw-py-1 tw-text-amber-700">{{ $t(
                                            'order-status.delivery.' + f.old_value) }}</td>
                                        <td class="tw-text-xs tw-px-2 tw-py-1 tw-text-green-700">{{ $t(
                                            'order-status.delivery.' + f.new_value) }}</td>
                                    </template>
                                    <template v-else>
                                        <td class="tw-text-xs tw-px-2 tw-py-1 tw-text-amber-700">{{
                                            f.old_value }}</td>
                                        <td class="tw-text-xs tw-px-2 tw-py-1 tw-text-green-700">{{
                                            f.new_value }}</td>
                                    </template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script setup>
import { defineProps, ref, toRef } from 'vue';
import moment from 'moment';

const columns = ref([
    { name: 'field', label: 'fields.field', classes: ['tw-w-[100px]'] },
    { name: 'old_value', label: 'fields.old_value', classes: [] },
    { name: 'new_value', label: 'fields.new_value', classes: [] },
])

const props = defineProps({
    data: {
        required: true
    },
    loading: {
        required: true,
        default: false
    },
});

const data = toRef(props, 'data');
</script>

<style></style>